/**
 * @generated SignedSource<<a49d0e9eec11f32863d2a2c53f6cc2b5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppManagementSceneVisitMutation$variables = {
  appId: string;
};
export type AppManagementSceneVisitMutation$data = {
  readonly visitApp: {
    readonly id: string;
  };
};
export type AppManagementSceneVisitMutation = {
  response: AppManagementSceneVisitMutation$data;
  variables: AppManagementSceneVisitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appId",
        "variableName": "appId"
      }
    ],
    "concreteType": "App",
    "kind": "LinkedField",
    "name": "visitApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppManagementSceneVisitMutation",
    "selections": (v1/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppManagementSceneVisitMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "108028c861a73468a7d4ad9f557272f7",
    "id": null,
    "metadata": {},
    "name": "AppManagementSceneVisitMutation",
    "operationKind": "mutation",
    "text": "mutation AppManagementSceneVisitMutation(\n  $appId: ID!\n) {\n  visitApp(appId: $appId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d354e604c1567aa9650e43534f380f43";

export default node;
